import React from 'react'
import { Modal } from '@material-ui/core'
import styled, { ITheme } from '../../theme'
import { useTranslation } from 'react-i18next'
import { Card, CardText, Title } from './Help'
import noMoney from '../../assets/integrations/no-money.svg'
import notAllowed from '../../assets/integrations/not-allowed.svg'
import brokenHeart from '../../assets/integrations/broken-heart.svg'
import Button from '../../components/Template/Button'
import { useGoToPremium } from '../../hooks/useGoToPremium'

const Wrapper = styled.div`
  min-width: 836px;
  width: 836px;
  max-height: 80vh;
  border-radius: 5px;
  background-color: #ebedef;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.2);
  stroke-width: 1;
  top: 50%;
  left: calc(50% - 224px);
  transform: translate(-50%, -50%);
  position: relative;
  outline: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 15px 20px 20px;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    left: 50%;
    min-width: unset;
    width: calc(100% - 30px);
  }
`

function NoPremium({ open }: IConnectModal) {
  const { t } = useTranslation()
  const [goToPremium] = useGoToPremium()
  return (
    <Modal
      hideBackdrop={true}
      disableScrollLock={true}
      disablePortal={true}
      BackdropProps={{ invisible: true, open: false }}
      open={open}
    >
      <Wrapper>
        <Title active={true}>{t('OUT_4831_no_premium_window_1')}</Title>
        <Card active={true} style={{ marginTop: '5px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              style={{
                width: '30px',
                height: '30px',
                marginRight: '10px',
                filter:
                  'invert(44%) sepia(80%) saturate(651%) hue-rotate(312deg) brightness(100%) contrast(104%)',
              }}
              alt={'lockdown'}
              src={noMoney}
            />
            <CardText>{t('OUT_4831_no_premium_window_2')}</CardText>
          </div>
        </Card>
        <Card active={true}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              style={{
                width: '30px',
                height: '30px',
                marginRight: '10px',
                filter:
                  'invert(44%) sepia(80%) saturate(651%) hue-rotate(312deg) brightness(100%) contrast(104%)',
              }}
              alt={'lockdown'}
              src={notAllowed}
            />
            <CardText>{t('OUT_4831_no_premium_window_3')}</CardText>
          </div>
        </Card>
        <Card active={true}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              style={{
                width: '30px',
                height: '30px',
                marginRight: '10px',
                filter:
                  'invert(44%) sepia(80%) saturate(651%) hue-rotate(312deg) brightness(100%) contrast(104%)',
              }}
              alt={'lockdown'}
              src={brokenHeart}
            />
            <CardText>{t('OUT_4831_no_premium_window_4')}</CardText>
          </div>
        </Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button onClick={goToPremium} primary={true}>
            {t('OUT_4258_airbnb_no_premium_button_2')}
          </Button>
        </div>
      </Wrapper>
    </Modal>
  )
}

export interface IConnectModal {
  open: boolean
}

export default NoPremium
